import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomFormsModule } from 'ng2-validation'
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSelectModule } from "ngx-select-ex";

import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ShopHeaderComponent } from './core/components/shop-header/shop-header.component';
import { ProductsComponent } from './shopping/components/products/products.component';
import { ProductCardComponent } from './shared/components/product-card/product-card.component';
import { ProductQuantityComponent } from './shared/components/product-quantity/product-quantity.component';
import { ProductFilterComponent } from './shopping/components/products/product-filter/product-filter.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CustomInterceptorService } from './shared/services/custom-interceptor.service';
import { ProductService } from './shared/services/product.service';
import { ShoppingCartService } from './shared/services/shopping-cart.service';
import { CategoriesService } from './shared/services/categories.service';
import { ShoppingCartComponent } from './shopping/components/shopping-cart/shopping-cart.component';
import { LandingPageComponent } from './shopping/components/landing-page/landing-page.component';
import { ProductSearchComponent } from './shopping/components/products/product-search/product-search.component';
import { CheckoutComponent } from './shopping/components/checkout/checkout.component';
import { ProductComponent } from './shopping/components/product/product.component';
import { OrderSuccessComponent } from './shopping/components/order-success/order-success.component';
import { DataService } from './shared/services/data.service';
import { MerchantService } from './shared/services/merchant.service';
import { FooterComponent } from './core/components/footer/footer.component';
import { PaymentComponent } from './shopping/components/payment/payment.component';
import { UtilsService } from './shared/services/utils.service';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { UssdPaymentComponent } from './shared/components/ussd-payment/ussd-payment.component';
import { InvalidStoreComponent } from './core/components/invalid-store/invalid-store.component';
import { CustomSliderComponent} from './shared/components/custom-slider/custom-slider.component'

@NgModule({
  declarations: [
    AppComponent,
    ShopHeaderComponent,
    ProductsComponent,
    ProductCardComponent,
    ProductQuantityComponent,
    ProductFilterComponent,
    ShoppingCartComponent,
    LandingPageComponent,
    ProductSearchComponent,
    CheckoutComponent,
    ProductComponent,
    OrderSuccessComponent,
    FooterComponent,
    PaymentComponent,
    UssdPaymentComponent,
    InvalidStoreComponent,
    CustomSliderComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    SlickCarouselModule,
    NgxSelectModule,
    CustomFormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true,
      timeOut: 4000
    }), PaginationModule.forRoot(),
  ],
  providers: [
    ProductService,
    ShoppingCartService,
    CategoriesService,
    DataService,
    MerchantService,
    UtilsService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
